<template>
  <div
    class="position-relative justify-content-center d-flex"
    @mouseleave="onMouseLeave()"
    @mouseover="onMouseOver()"
  >
    <Button
      @onClick="onClick"
      fullWidth
      :loading="loading"
      :outline="outline"
      :label="label"
      :color="color"
      :id="id"
    />
    <div
      id="form_field_error"
      v-if="showError && fieldError"
      class="position-absolute shadow bg-danger-subtle rounded p-3"
      style="bottom: 50px; z-index: 10"
    >
      <Typograph variant="subtitle" class="text-danger">
        <i class="fa-solid fa-exclamation-circle"></i>
        {{ fieldError }}
      </Typograph>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import Button from "./Button.vue";
import { ErrorObject } from "@vuelidate/core";

export default defineComponent({
  extends: Button,
  emits: ["onSubmit"],
  props: {
    errors: {
      type: Array as PropType<ErrorObject[]>,
    },
  },
  computed: {
    fieldError(): string {
      if (!this.errors) return "";
      const messages = this.errors?.map((error: any) => error.$message);
      return messages.length ? messages[0] : "";
    },
  },
  data() {
    return {
      showError: false,
    };
  },
  methods: {
    onClick() {
      if (this.fieldError) return;
      this.showError = true;
      this.$emit("onSubmit");
    },
    onMouseOver() {
      this.showError = true;
    },
    onMouseLeave() {
      this.showError = false;
    },
  },
});
</script>
